<template>
    <access-denied v-if="accessDenied" title="conta-corrente" />
    <div id="main" v-else>
        <Loader v-if="isLoading" />
        <div class="page">
            <AlertContainer :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('gerenciar-saldo') }}</h1>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$emit('voltar', true)"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                permissao.create &&
                                !integracao
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <h2 class="mb-5">
                    <strong class="has-text-primary f-9">
                        Por favor, confirme os dados abaixo com ATENÇÃO, você esta APROVANDO o saldo na conta do usuário!
                    </strong>
                </h2>
                <div class="form-columns-fit">
                    <div class="column is-12 is-flex is-flex-column g-1 p-0 mb-6">
                        <p>
                            <strong>Empresa: </strong>
                            {{ contaFlex.nomeEmpresa }}
                        </p>
                        <p>
                            <strong>Colaborador: </strong>
                            {{ contaFlex.nomeUsuario }}
                        </p>
                    </div>
                    <div class="columns is-flex-wrap mb-4">
                        <div class="column is-6">
                            <vss-select
                                ref="motivoSelected"
                                required
                                title="motivo-lancamento"
                                v-model="detalhesSaldo.motivoSelected"
                                :invalid="isNull(detalhesSaldo.motivoSelected)"
                                :options="motivoList"
                                :loading="motivoLoading"
                                @search="carregarMotivo"
                                :placeholder="'selecione-uma-opcao'"
                            />
                        </div>
                        <div class="column is-flex is-flex-vcenter is-flex-hcenter">
                            <b-field>
                                <b-radio-button v-model="detalhesSaldo.situacaoSaldo"
                                    :native-value="0"
                                    type="is-danger is-light is-outlined">
                                    <b-icon icon="close"></b-icon>
                                    <span>Bloquear</span>
                                </b-radio-button>
    
                                <b-radio-button v-model="detalhesSaldo.situacaoSaldo"
                                    :native-value="1"
                                    type="is-success is-light is-outlined">
                                    <b-icon icon="check"></b-icon>
                                    <span>Liberar</span>
                                </b-radio-button>
                            </b-field>
                        </div>
                        <div class="column is-6" v-show="detalhesSaldo.motivoSelected ? 
                                    detalhesSaldo.motivoSelected.habilitaobrigaobservacao == 1 || 
                                    detalhesSaldo.motivoSelected.habilitaobrigaobservacao == 2 : false">
                            <v-textarea
                                ref="observacaoInput"
                                v-model="detalhesSaldo.observacao"
                                title="observacao"
                                :rows="4"
                                :maxRows="6"
                                :invalid="isNull(detalhesSaldo.observacao)"
                                :required="detalhesSaldo.motivoSelected ? detalhesSaldo.motivoSelected.habilitaobrigaobservacao == 2 : false"
                                :disableTransform="true"
                                :disabled="isSaving"
                            />
                        </div>
                    </div>
                    <div class="form-columns-fit mt-4 pb-4">
                        <div class="columns is-flex-wrap">
                            <b-table
                                :data="liberaSaldos"
                                class="data-table"
                                striped
                            >
                                <b-table-column
                                    v-for="(f, i) in fields"
                                    :key="i"
                                    :field="f.key"
                                    :label="$t(f.label)"
                                    :width="f.width"
                                    :sortable="f.sortable"
                                    :visible="f.visible"
                                    v-slot="props"
                                    :header-class="f.key == 'label' && !isMobile() ? 'remove-space' : ''"
                                    :cell-class="f.key == 'label' && !isMobile() ? 'remove-space' : ''"
                                >
                                    <template v-if="f.key === 'valorPedido'">
                                        <p 
                                            :class="{ 'is-debit': props.row.pedido.valortotal < 0 }"
                                        >
                                            {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(props.row.pedido.valortotal) }}
                                        </p>
                                    </template>
                                    <template v-else-if="f.key === 'saldoGerado'">
                                        <p 
                                            :class="{ 'is-debit': props.row[f.key] < 0 }"
                                        >
                                            {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(props.row[f.key]) }}
                                        </p>
                                    </template>
                                    <template v-else-if="f.key === 'saldoLiberado'">
                                        <v-money
                                            v-model="props.row[f.key]"
                                            :invalid="isNull(props.row[f.key])"
                                            :max="9999999"
                                            :min="-9999999"
                                            :disabled="isSaving || detalhesSaldo.situacaoSaldo === 0"
                                        />
                                    </template>
                                    <template v-else>
                                        {{ props.row[f.key] }}
                                    </template>
                                </b-table-column>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MotivoService from '@/services/agro/MotivoService.js';
import FlexLancamentoService from '@/services/vendas/financeiro/FlexLancamentoService.js';
import FlexLancamentoValidation from '@/services/validations/financeiro/flex/FlexLancamentoValidation.js';
import Loader from '@/components/content/loader/Loader.vue';
import AlertContainer from '@/components/shared/AlertContainer.vue';

export default {
    name: 'FlexGerenciaSaldoManage',
    components: {
        Loader,
        AlertContainer,
    },
    props: {
        contaFlex: {
            type: Object,
            default: (_) => null,
        },
        saldosSelecionados: {
            type: Array,
            default: (_) => [],
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('VEN_FLEX_LANCAMENTO'),
            service: new FlexLancamentoService(this.$http, this.$router),
            motivoService: new MotivoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            fields: [
                { key: 'idPedido', label: 'pedido', width: null, sortable: false, visible: true },
                { key: 'nomeCliente', label: 'cliente', width: null, sortable: false, visible: true },
                { key: 'valorPedido', label: 'valor-pedido', width: null, sortable: false, visible: true },
                { key: 'saldoGerado', label: 'saldo-flex', width: null, sortable: false, visible: true },
                { key: 'saldoLiberado', label: 'saldo-liberado', width: 200, sortable: false, visible: true },
            ],
            liberaSaldos: [],
            detalhesSaldo: {
                situacaoSaldo: 0,
                motivoSelected: null,
                observacao: ""
            },
            isSaving: false,
            validation: new FlexLancamentoValidation(),
            accessDenied: false,
            motivoList: [],
            motivoSelected: null,
            motivoLoading: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'financeiro', 'flex');

        this.liberaSaldos = this.saldosSelecionados.map(({saldoGerado, ...rest}) => ({saldoGerado, saldoLiberado: saldoGerado, ...rest}))
        
        if (!this.permissao.create) {
            this.accessDenied = true;
        }
    },
    methods: {
        save() {
            this.isLoading = true;

            const liberaSaldosMapped = this.liberaSaldos.map(({...rest}) => ({
                ...rest,
                idVenFlex: this.contaFlex.id,
                situacaoSaldo: this.detalhesSaldo.situacaoSaldo,
                idMotivo: this.detalhesSaldo.motivoSelected ? this.detalhesSaldo.motivoSelected.id : null,
                observacao: this.detalhesSaldo.observacao
            }))
            
            const isInvalidForm = liberaSaldosMapped.some((saldo) => this.validation.validate(saldo, this.$refs) === false)

            if (isInvalidForm) {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                this.isLoading = false;
                return;
            }
            this.isSaving = true;
            
            this.service
                .movimentaSaldo(liberaSaldosMapped)
                .then((value) => {
                    if (value.message == null) {
                        const msg = this.$t('movimentacao-sucesso')

                        this.$root.showMessage('success', msg, true, false);
                        this.liberaSaldos = [];
                        this.$emit('saved');
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage('alert', value.message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    }
                })
                .catch((e) => {
                    const responseBodyValidation = e.body && !this.isNull(e.body.message) && this.$te(e.body.message);
                    
                    if (responseBodyValidation) {
                        this.$root.showMessage('alert', this.$t(e.body.message), true, false);
                    } else {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                    }
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                });
        },
        carregarMotivo() {
            this.motivoLoading = true
            this.motivoService
                .findAll(
                    "motivo", 
                    "desc", 
                    0, 
                    10000, 
                    1,
                    [".*", "CONTA_CORRENTE_FLEX"]
                )
                .then(response => {
                    this.motivoList = response.content
                        .filter(({ inicio: isMotivoInicio }) => !isMotivoInicio)
                        .map(
                            ({id, descricao: label, cor, icone, habilitaobrigaobservacao, inicio}) => 
                            ({id, label, cor, icone: icone.toLowerCase(), habilitaobrigaobservacao, inicio})
                        )
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.motivoLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.f-9 {
    font-size: 18px;
}
.g-1 {
    gap: 4px;
}
#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
        padding-left: 0;
    }
    .sovis-container-user {
        cursor: pointer;
        padding: 2px 10px;
        border: solid 1px $primary-color;
        background-color: #f0f0f0;
        border-radius: 6px;
        display: flex;
        .qtd-users {
            font-weight: bolder;
            font-size: 18px;
            margin: 0 10px;
            &.is-success {
                color: $green-alert;
            }
            &.is-danger {
                color: $orange;
            }
        }
    }
}
</style>
